// Generated by `yarn tokens:import --aos-ds` from the Figma "Semantic" variables export. Do not edit.
//
// The Figma content/* group — the inks a text style is allowed to take.
// Tone names and class names are Figma's own alias, because aos-ds has its own
// preset and carries none of aos-ui-universal's group renames.

export type FigmaTextColor = {
    alias: string
    className: string
}

export const textColors = {
    'default': {
        alias: 'content/default',
        className: 'text-content-default',
    },
    'destructive': {
        alias: 'content/destructive',
        className: 'text-content-destructive',
    },
    'inverted': {
        alias: 'content/inverted',
        className: 'text-content-inverted',
    },
    'knockout': {
        alias: 'content/knockout',
        className: 'text-content-knockout',
    },
    'link': {
        alias: 'content/link',
        className: 'text-content-link',
    },
    'link-hover': {
        alias: 'content/link-hover',
        className: 'text-content-link-hover',
    },
    'link-pressed': {
        alias: 'content/link-pressed',
        className: 'text-content-link-pressed',
    },
    'link-visited': {
        alias: 'content/link-visited',
        className: 'text-content-link-visited',
    },
    'logotype': {
        alias: 'content/logotype',
        className: 'text-content-logotype',
    },
    'muted': {
        alias: 'content/muted',
        className: 'text-content-muted',
    },
    'on-action': {
        alias: 'content/on-action',
        className: 'text-content-on-action',
    },
    'on-primary': {
        alias: 'content/on-primary',
        className: 'text-content-on-primary',
    },
} as const satisfies Record<string, FigmaTextColor>

export const FIGMA_TEXT_COLOR_GROUP = 'content'
